// src/plugins/vuetify/theme.js
import colors from "vuetify/lib/util/colors";
import { VuetifyThemeVariant } from "vuetify/types/services/theme";

const theme: VuetifyThemeVariant = {
    primary: {
        base: colors.purple.base,
        darken1: colors.purple.darken1,
    },
    secondary: "",
    accent: "",
    info: "",
    warning: "",
    success: "",
    error: "",
};
export default theme;
// {
//   primary: {
//     base: colors.purple.base,
//     darken1: colors.purple.darken2,
//   },
//   secondary: colors.indigo,
//   // All keys will generate theme styles,
//   // Here we add a custom `tertiary` color
//   tertiary: colors.pink.base,
// }
